import { useState, useEffect } from "react";
import Modal from "../../modal";
import styles from "./styles.module.css";
import * as Editors from "../../editors";
import { makeid } from "../../utils/pageactions";

export default function Params({ open, onClose, onSubmit, sources, method }) {
  const [_method, setMethod] = useState(null);

  useEffect(() => {
    if (open) {
      if (method) {
        setMethod(method);
      } else {
        console.log(open);
        setMethod({
          value: open.code,
          name: open.name,
          returnType: open.returnType,
          returnList: open.returnList,
          props: {},
          params: open.params.map((x) => ({
            name: x.name,
            displayName: x.displayName,
            format: x.format ? x.format : null,
          })),
          id: makeid(16),
          async: open.async ? open.async : null,
        });
      }
    }
  }, [method, open]);

  const handleSubmit = () => {
    let returnType = "";
    let returnList = false;
    if (_method.props[open.returnType]) {
      returnType = _method.props[open.returnType];
    } else {
      returnType = open.returnType;
    }
    if (_method.props[open.returnList]) {
      returnList = _method.props[open.returnList];
    } else {
      returnList = open.returnList;
    }

    const method = { ..._method, returnList, returnType };
    onSubmit(method, open.index);
  };

  const handleChange = (value, param) => {
    const method = { ..._method };
    method.props[param.name] = value;
    setMethod(method);
  };
  if (!open || !_method) {
    return null;
  }
  return (
    <Modal onClose={onClose} open={open}>
      <div className={styles.params}>
        <div className={styles.paramTitle}>{open.name}</div>
        {open.params.map((p) => (
          <ParamInput
            key={p.name}
            method={_method}
            sources={sources}
            param={p}
            onChange={(v) => handleChange(v, p)}
          />
        ))}
        <button onClick={handleSubmit} className={styles.paramButton}>
          Save
        </button>
      </div>
    </Modal>
  );
}

const ParamInput = ({ param, method, onChange, sources }) => {
  const [_sources, setSources] = useState([]);
  const [params, setParmas] = useState(param.editorParams);
  const Input = Editors[param.editor];

  useEffect(() => {
    const _params = { ...param.editorParams };

    Object.keys(param.editorParams || {}).forEach((key) => {
      if (key === "type") {
        if (param.editorParams.type === "*") {
          return (_params.type = method.returnType);
        }
        if (method.props[param.editorParams[key]]) {
          return (_params.type = method.props[param.editorParams[key]]);
        }
      }
    });
    setParmas(_params);
  }, [param.editorParams, method]);
  useEffect(() => {
    try {
      if (param.editorParams.sources) {
        const paramSources = param.editorParams.sources.map((s) => {
          const _s = { ...s };

          if (s.returnType === "*") {
            _s.returnType = method.returnType;
          }
          return _s;
        });
        setSources([...paramSources, ...sources]);
      }
    } catch (err) {
      return setSources(sources);
    }
  }, [sources, param]);

  if (!Input) {
    return null;
  }

  return (
    <div className={styles.paramInput}>
      <div className={styles.paramInputTitle}>{param.displayName}</div>
      <Input
        value={method.props[param.name]}
        onChange={onChange}
        params={params}
        sources={_sources}
      />
      <div className={styles.paramInputTitle}>{param.help}</div>
    </div>
  );
};
